<template>
  <v-card class="session__container">
    <div class="session__content">
      <div>
        <v-img
          src="@/static/brand_logo.svg"
          class="mx-auto session__logo"
          aspect-ratio
          width="300"
        >
        </v-img>
      </div>
      <h3 class="text-center mb-5">
        {{ $t("message.serviceUnavailable.title") }}
      </h3>
      <p class="text-center mb-5">
        {{ $t("message.serviceUnavailable.description") }}
      </p>
      <p class="text-center mb-0">
        {{ $t("message.serviceUnavailable.footer") }}
      </p>
      <p
        class="text-center mb-5"
        v-html="$t('message.serviceUnavailable.signature')"
      ></p>
    </div>

    <div class="d-flex justify-center">
      <ui-button class="my-4" color="primary" outlined href="https://center.ai">
        {{ $t("message.serviceUnavailable.backToMainPage") }}
      </ui-button>
    </div>
  </v-card>
</template>

<script>
import { FEATURE_FLAG, isFeatureFlagEnabled } from "@/helpers/posthog";

export default {
  name: "MaintenanceMode",
  created() {
    if (!this.isServiceUnavailable) {
      this.$router.push("/");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isServiceUnavailable) {
      next();
    }
  },
  computed: {
    isServiceUnavailable() {
      return isFeatureFlagEnabled(FEATURE_FLAG.SERVICE_UNAVAILABLE);
    }
  }
};
</script>
